module.exports = __webpack_public_path__ + "static/media/jaymes-young-logo.cc55db69.svg";